/* PISOS MANRIQUEZ - Carrusel hero + barra promo + sticky + hover de navbar. v3.0 */
(function () {
  'use strict';
  if (window.__pmHeroReady) return;
  window.__pmHeroReady = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    var nodes = (root || document).querySelectorAll('[data-pm-hc]:not([data-pm-hc-init])');
    Array.prototype.forEach.call(nodes, function (hc) {
      hc.setAttribute('data-pm-hc-init', '1');

      var slides = hc.querySelectorAll('[data-pm-hc-slide]');
      var dots = hc.querySelectorAll('[data-pm-hc-dot]');
      var prev = hc.querySelector('[data-pm-hc-prev]');
      var next = hc.querySelector('[data-pm-hc-next]');
      if (slides.length < 1) return;

      var i = 0, timer = null, hoverLock = false;
      var delay = parseInt(hc.getAttribute('data-pm-hc-delay') || '6000', 10);
      var auto = hc.getAttribute('data-pm-hc-auto') === 'true' && slides.length > 1 && !reduced;

      /* Precarga: sin esto los slides aparecen en negro la primera vez. */
      function preload() {
        Array.prototype.forEach.call(slides, function (s) {
          var im = s.querySelector('img');
          if (!im) return;
          im.setAttribute('loading', 'eager');
          if (!im.complete) {
            var pre = new Image();
            if (im.srcset) pre.srcset = im.srcset;
            pre.src = im.currentSrc || im.src;
          }
        });
      }
      if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 2500 });
      else setTimeout(preload, 1200);

      function show(n) {
        i = (n + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (s, k) {
          s.classList.toggle('is-active', k === i);
          s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        });
        Array.prototype.forEach.call(dots, function (d, k) {
          d.classList.remove('is-active');
          var bar = d.querySelector('i');
          if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; bar.offsetHeight; bar.style.transition = ''; }
          if (k === i) d.classList.add('is-active');
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      }

      function start() { if (auto && !hoverLock) { stop(); timer = setInterval(function () { show(i + 1); }, delay); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function go(n) { show(n); start(); }

      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      Array.prototype.forEach.call(dots, function (d, k) { d.addEventListener('click', function () { go(k); }); });

      hc.addEventListener('mouseenter', stop);
      hc.addEventListener('mouseleave', start);
      hc.addEventListener('focusin', stop);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      var x0 = null, y0 = null;
      hc.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
      hc.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? i + 1 : i - 1);
        x0 = null; y0 = null; start();
      }, { passive: true });

      hc.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(i - 1);
        if (e.key === 'ArrowRight') go(i + 1);
      });

      /* ---------- Hover en la navbar cambia el slide ----------
         Cada slide declara data-pm-cat con el handle de su categoria.
         Al pasar el mouse por esa categoria en el menu, saltamos a su slide. */
      var byCat = {};
      Array.prototype.forEach.call(slides, function (s, k) {
        var c = (s.getAttribute('data-pm-cat') || '').trim().toLowerCase();
        if (c) byCat[c] = k;
      });

      if (Object.keys(byCat).length) {
        var links = document.querySelectorAll('.header__inline-menu a[href*="/collections/"]');
        var backTimer = null;

        Array.prototype.forEach.call(links, function (a) {
          var m = (a.getAttribute('href') || '').match(/\/collections\/([a-z0-9-]+)/i);
          if (!m) return;
          var handle = m[1].toLowerCase();
          if (!(handle in byCat)) return;

          a.addEventListener('mouseenter', function () {
            clearTimeout(backTimer);
            hoverLock = true;
            stop();
            show(byCat[handle]);
          });

          a.addEventListener('mouseleave', function () {
            clearTimeout(backTimer);
            backTimer = setTimeout(function () { hoverLock = false; start(); }, 700);
          });
        });
      }

      hc.style.setProperty('--pm-hc-dur', (delay / 1000) + 's');
      show(0);
      start();
    });
  }

  function initPromobar(root) {
    var bars = (root || document).querySelectorAll('[data-pm-promobar]:not([data-pm-pb-init])');
    Array.prototype.forEach.call(bars, function (bar) {
      bar.setAttribute('data-pm-pb-init', '1');
      var msgs = bar.querySelectorAll('[data-pm-pb-msg]');
      if (msgs.length < 1) return;
      msgs[0].classList.add('is-on');
      if (msgs.length < 2 || reduced) return;
      var n = 0;
      var every = parseInt(bar.getAttribute('data-pm-pb-delay') || '5000', 10);
      setInterval(function () {
        msgs[n].classList.remove('is-on');
        n = (n + 1) % msgs.length;
        msgs[n].classList.add('is-on');
      }, every);
    });
  }

  function initSticky() {
    if (document.documentElement.hasAttribute('data-pm-sticky-init')) return;
    document.documentElement.setAttribute('data-pm-sticky-init', '1');
    var ticking = false;
    function check() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      document.documentElement.classList.toggle('pm-scrolled', y > 140);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    check();
  }

  function boot(root) { initCarousel(root); initPromobar(root); initSticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pm-hc]');
    if (el) el.removeAttribute('data-pm-hc-init');
    var pb = e.target.querySelector('[data-pm-promobar]');
    if (pb) pb.removeAttribute('data-pm-pb-init');
    boot(e.target);
  });
})();
